import { ICardUserUI } from "./types"

import { useDeviceType } from "@hooks/useDeviceType"

import { getInputButton } from "@primitive/getInputButton"

import { Button, Divider, Drawer, Empty, Flex, Input, Loader, Toogle, ToolTip, Table } from "@ui/index"

import imgEmty from '@img/empty.svg'
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'
import { 
    IconApplications, IconClearClose, IconContracts, 
    IconDelete, IconDelivery, IconEntity, IconJobs, 
    IconKP, IconListeners, IconSignature, IconUsers 
} from "@img/icons"

import css from './ui.module.scss'
import { DictSelectorContainer } from "@smart/dictSelector"


/** Анкета - Операторы */
export const CardUserUI = ({
    isOpen, isLoadingCard, 
    isLoadingCheckedSectionRead,
    isLoadingCheckedSectionEdit, 
    isLoadingCheckedSectionDelete, 
    currentCardID, currentCardMode,
    fieldsError, isDisableBtnSave,
    txtLoginName, txtLoginPassword, 
    txtAccessLevelID, txtAccessLevelName, txtIsLocked,
    txtLastName, txtFirstName, txtSecondName,
    itemsSites, itemsAccess, 

    generatePassword, dictSelectorData,
    handleBtnClose, handleOpenModalConfirm, handleBtnSave, 
    handleOnChangeAccessSection
}: ICardUserUI) => {
    const deviceType = useDeviceType()

    /** Вазвращает лого сайта */
    const getLogoSite = (dbName: string) => {
        switch (dbName) {
            case 'modern_academy': return logoModSkill
            case 'yaskill': return logoYaSkill
        }
    }

    /** Вазвращает лого раздела */
    const getLogoSection = (accessSectionID: number) => {
        switch (accessSectionID) {
            case 1: return <IconApplications width="28px" height="28px" /> // Заявки
            case 2: return <IconKP width="28px" height="28px" /> // Ком. предложения
            case 3: return <IconEntity width="28px" height="28px" /> // Контрагенты
            case 4: return <IconListeners width="28px" height="28px" /> // Слушатели
            case 5: return <IconContracts width="28px" height="28px" /> // Договора
            case 6: return <IconJobs width="28px" height="28px" /> // Итоговые работы
            case 7: return <IconDelivery width="28px" height="28px" /> // Доставка
            case 8: return <IconUsers width="28px" height="28px" /> // Операторы
            case 9: return <IconSignature width="28px" height="28px" /> // Договора на подпись
        }
    }    

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='100%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header>
                        <Flex gap='4px' flexDirection='row' alignItems='center'>
                            <IconUsers color='#fff' width='20px' height='20px' />
                            <h4>{currentCardMode.value === 'edit' ? `Анкета оператора № ${currentCardID.value}` : 'Создание оператора'}</h4>
                        </Flex>
                    </header>

                    <Button variant='icon' size='xs' isDisabled={isLoadingCard} onClick={handleBtnClose}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                    <Loader isOpen={isLoadingCard} backdrop={true} title="Загрузка данных..." />

                    <Flex gap='20px' className='drawer_container-content'>
                        <Flex gap="5px">
                            <Divider gap="6px"
                                prefix={<h4>Основные данные</h4>} 
                                suffix={<>
                                    <ToolTip title={txtIsLocked.value === 0 ? 'Заблокировать' : 'Разблокировать'} placement="left">
                                        <Toogle checked={txtIsLocked.value === 0 ? false : true} 
                                            onChange={(e) => txtIsLocked.setValue(e.target.checked === false ? 0 : 1)}
                                        />
                                    </ToolTip>
                                </>}
                            />

                            <Flex gap="15px">
                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.loginName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Логин оператора <p className="pulse"></p></Flex>

                                        <Input placeholder="Логин оператора"
                                            suffix={txtLoginName.value && getInputButton('clear', txtLoginName.reset)}
                                            value={txtLoginName.value} onChange={(e) => txtLoginName.setValue(e.target.value)}
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.loginPassword ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Пароль оператора <p className="pulse"></p></Flex>
                                        
                                        <Input placeholder="Пароль оператора" 
                                            suffix={<>
                                                {txtLoginPassword.value && getInputButton('clear', txtLoginPassword.reset)}
                                                {getInputButton('update', () => txtLoginPassword.setValue(generatePassword()))}
                                            </>}
                                            value={txtLoginPassword.value} onChange={(e) => txtLoginPassword.setValue(e.target.value)}
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.accessLevel ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Должность оператора <p className="pulse"></p></Flex>
                                        
                                        <Input placeholder="Должность оператора" isReadOnly
                                            value={txtAccessLevelName.value} onChange={(e) => txtAccessLevelName.setValue(e.target.value)}
                                            suffix={
                                                <DictSelectorContainer isScroll={false} isSearch={false} dictName="accessLevels" 
                                                    onSelect={(data) => { dictSelectorData('accessLevels', data) }}
                                                >{getInputButton('select')}</DictSelectorContainer>
                                            }
                                        />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.lastName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Фамилия оператора <p className="pulse"></p></Flex>

                                        <Input placeholder="Фамилия оператора"
                                            suffix={txtLastName.value && getInputButton('clear', txtLastName.reset)}
                                            value={txtLastName.value} onChange={(e) => txtLastName.setValue(e.target.value)}
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.firstName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Имя оператора <p className="pulse"></p></Flex>
                                        
                                        <Input placeholder="Имя оператора" 
                                            suffix={txtFirstName.value && getInputButton('clear', txtFirstName.reset)}
                                            value={txtFirstName.value} onChange={(e) => txtFirstName.setValue(e.target.value)}
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='250px'>
                                        <Flex gap="5px" flexDirection="row" className="input_header">Отчество оператора</Flex>
                                        
                                        <Input placeholder="Отчество оператора"
                                            suffix={txtSecondName.value && getInputButton('clear', txtSecondName.reset)}
                                            value={txtSecondName.value} onChange={(e) => txtSecondName.setValue(e.target.value)}
                                        />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>

                        <Flex gap="5px" isRendered={(txtAccessLevelID.value !== 0 && currentCardMode.value === 'edit')}>
                            <Divider gap="6px" 
                                prefix={<h4>Доступные сайты</h4>} 
                                suffix={
                                    <DictSelectorContainer isScroll={false} isSearch={false} dictName="accessSites"
                                        onSelect={(data) => { dictSelectorData('accessSites', data) }}
                                    ><Button size="sm" padding="4px 8px">Добавить</Button></DictSelectorContainer>
                                }
                            />

                            <Table.Container>
                                <Table.Content isScrollVertical={false}>
                                    {itemsSites.value.length === 0
                                        ? <Empty image={imgEmty} title='Данные отсутствуют' />
                                        : itemsSites.value.map((item, index) => {
                                            return (
                                                <Table.Row key={`${item.loginSiteID}`} className={css['table_grid_columns_row_sites']}>
                                                    <img src={getLogoSite(item.siteDBName)} alt="Лого сайта" />

                                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                        <p>{item.siteDbNameDescription}</p>
                                                        <p style={{ opacity: '.7' }}>{item.siteLink}</p>
                                                    </div>

                                                    <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                                        <ToolTip title='Удалить' placement="left">
                                                            <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'} onClick={(e) => {
                                                                handleOpenModalConfirm(true,
                                                                    'Удаление доступа к сайту',
                                                                    `Вы действительно хотите удалить доступ к сайту ${item.siteLink}`,
                                                                    "deleteUserSite", item.loginSiteID
                                                                )
                                                                e.stopPropagation()
                                                            }}><IconDelete width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                                        </ToolTip>
                                                    </Flex>
                                                </Table.Row>
                                            )
                                        })
                                    }
                                </Table.Content>
                            </Table.Container>
                        </Flex>

                        <Flex gap="5px" isRendered={(txtAccessLevelID.value !== 0 && txtAccessLevelID.value !== 1  && currentCardMode.value === 'edit')}>
                            <Divider gap="6px" 
                                prefix={<h4>Доступные разделы</h4>} 
                                suffix={
                                    <DictSelectorContainer isSearch={false} dictName="accessSections"
                                        onSelect={(data) => { dictSelectorData('accessSections', data) }}
                                    ><Button size="sm" padding="4px 8px">Добавить</Button></DictSelectorContainer>
                                }
                            />

                            <Table.Container>
                                <Table.Header paddingLeft="44px" paddingRight="56px" classNameContainer="" classNameContent={css['table_grid_columns_header_section']}>
                                    <p>Раздел</p>
                                    <p style={{textAlign:'center'}}>Чт-е</p>
                                    <p style={{textAlign:'center'}}>Ред-е</p>
                                    <p style={{textAlign:'center'}}>Уд-е</p>
                                </Table.Header>

                                <Table.Content isScrollVertical={false}>
                                    {itemsAccess.value.length === 0
                                        ? <Empty image={imgEmty} title='Данные отсутствуют' />
                                        : itemsAccess.value.map((item, index) => {
                                            return (
                                                <Table.Row key={`${item.accessID}`} className={css['table_grid_columns_row_section']}>
                                                    {getLogoSection(item.accessSectionID)}

                                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                        <p>{item.accessSectionName}</p>
                                                        <p style={{ opacity: '.7' }}>{item.accessSectionDescription}</p>
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Toogle isLoading={isLoadingCheckedSectionRead}
                                                            checked={item.isRead === 0 ? false : true}
                                                            onChange={(e) => handleOnChangeAccessSection(item.accessID, 'read', e.target.checked)}
                                                        />
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Toogle isLoading={isLoadingCheckedSectionEdit}
                                                            checked={item.isEdit === 0 ? false : true}
                                                            onChange={(e) => handleOnChangeAccessSection(item.accessID, 'edit', e.target.checked)}
                                                        />
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Toogle isLoading={isLoadingCheckedSectionDelete}
                                                            checked={item.isDelete === 0 ? false : true}
                                                            onChange={(e) => handleOnChangeAccessSection(item.accessID, 'delete', e.target.checked)}
                                                        />
                                                    </div>

                                                    <Flex gap="8px" flexDirection="row" alignItems="center" justifyContent="center">
                                                        <Divider type="vertical" size="20px" />

                                                        <ToolTip title='Удалить' placement="left">
                                                            <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'} onClick={(e) => {
                                                                handleOpenModalConfirm(true,
                                                                    'Удаление доступа к разделу',
                                                                    `Вы действительно хотите удалить доступ к разделу ${item.accessSectionDescription}`,
                                                                    "deleteUserAccess", item.accessID
                                                                )
                                                                e.stopPropagation()
                                                            }}><IconDelete width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                                        </ToolTip>
                                                    </Flex>
                                                </Table.Row>
                                            )
                                        })
                                    }
                                </Table.Content>
                            </Table.Container>
                        </Flex>
                    </Flex>

                    <Divider />

                    <Flex flexWrap='wrap' flexDirection='row' gap='4px'>
                        <Flex flexDirection='row' gap='4px' justifyContent="flex-start">
                            <Button flexGrow={1} padding='0 10px' 
                                isDisabled={isDisableBtnSave.value || isLoadingCard}
                                onClick={() => handleBtnSave(true)}
                            >Сохранить и закрыть</Button>

                            <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoadingCard} 
                                onClick={() => handleBtnSave(false)}
                            >Сохранить</Button>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Drawer>
    </>
}